module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_2.fa2db6ca.png";